'use client';
import { type PropsWithChildren } from 'react';
import AppHeader from '@/components/AppHeader';
import { classes } from './utils';

export default function StorefrontLayout({ children }: PropsWithChildren) {
  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <AppHeader />
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
